import React from "react";
import { Link } from "react-router-dom";
import { Wordmark } from "./FyllrMark";

export default function Footer() {
  return (
    <footer className="bg-bone border-t border-sand" data-testid="site-footer">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div className="flex flex-col gap-1">
          <Wordmark size="md" />
          <p className="text-xs text-ink/50" data-testid="footer-launch-date">Early access 7 January · Public launch 7 February 2027 · Melbourne</p>
        </div>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-ink/60">
          <Link to="/join" className="hover:text-ink transition-colors" data-testid="footer-link-early-access">Get early access</Link>
          <Link to="/salon/login" className="hover:text-ink transition-colors" data-testid="footer-link-salons">For Salons</Link>
          <a href="/#signup" className="hover:text-ink transition-colors" data-testid="footer-link-waitlist">Get Early Access</a>
          <a href="https://www.instagram.com/fyllr.au/" target="_blank" rel="noreferrer noopener" className="hover:text-ink transition-colors" data-testid="footer-link-instagram">Instagram</a>
          <a href="https://www.tiktok.com/@fyllr.app" target="_blank" rel="noreferrer noopener" className="hover:text-ink transition-colors" data-testid="footer-link-tiktok">TikTok</a>
          <Link to="/terms" className="hover:text-ink transition-colors" data-testid="footer-link-terms">Terms</Link>
          <Link to="/privacy" className="hover:text-ink transition-colors" data-testid="footer-link-privacy">Privacy Policy</Link>
          <Link to="/partner-agreement" className="hover:text-ink transition-colors" data-testid="footer-link-partner-agreement">Partner Agreement</Link>
          <a href="mailto:info@fyllr.app" className="hover:text-ink transition-colors" data-testid="footer-email">info@fyllr.app</a>
        </div>
      </div>
    </footer>
  );
}
